import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const BRAND = "#4475a5";
const BIKE = "#10b981";

const RevenueComparisonChart = ({ revenue }) => {
  const totalCarRevenue = revenue?.totalCarRevenue || 0;
  const totalBikeRevenue = revenue?.totalBikeRevenue || 0;
  const totalRevenue = totalCarRevenue + totalBikeRevenue;

  return (
    <div className="dashboard-donut-stack">
      <div className="dashboard-donut-meter dashboard-donut-meter--lg">
        <CircularProgressbar
          value={100}
          text={` ${totalRevenue.toLocaleString()} Pkr `}
          styles={buildStyles({
            textSize: "11px",
            textColor: "#0f172a",
            pathColor: BRAND,
            trailColor: "#e8edf3",
          })}
        />
      </div>

      <div className="dashboard-revenue-legend">
        <div className="dashboard-revenue-legend__row">
          <span className="dashboard-revenue-legend__swatch" style={{ backgroundColor: BRAND }} />
          <span className="dashboard-revenue-legend__text">
            Motor Car: Rs. {totalCarRevenue.toLocaleString()}
          </span>
        </div>
        <div className="dashboard-revenue-legend__row">
          <span className="dashboard-revenue-legend__swatch" style={{ backgroundColor: BIKE }} />
          <span className="dashboard-revenue-legend__text">
            Bike: Rs. {totalBikeRevenue.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RevenueComparisonChart;
